// extracted by mini-css-extract-plugin
module.exports = {"select":"CustomSelect_select__3OH8j","arrow":"CustomSelect_arrow__16Mnz"};